import { render, staticRenderFns } from "./LabelModal8.vue?vue&type=template&id=1f20f2ea&scoped=true&"
import script from "./LabelModal8.vue?vue&type=script&lang=js&"
export * from "./LabelModal8.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal8.vue?vue&type=style&index=0&id=1f20f2ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20f2ea",
  null
  
)

export default component.exports